import { render, staticRenderFns } from "./DocumentsTab.vue?vue&type=template&id=32948c78&scoped=true"
import script from "./DocumentsTab.vue?vue&type=script&lang=js"
export * from "./DocumentsTab.vue?vue&type=script&lang=js"
import style0 from "./DocumentsTab.vue?vue&type=style&index=0&id=32948c78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32948c78",
  null
  
)

export default component.exports